import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  onDateRangeChange(event) {
    const customFields = document.getElementById("custom-date-fields")
    if (customFields) {
      if (event.target.value === "custom") {
        customFields.classList.remove("hidden")
      } else {
        customFields.classList.add("hidden")
      }
    }
  }
}
